/**
 * Api Documentation
 * Api Documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { LoggingEntryDTO } from '../model/loggingEntryDTO';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ApplicationRemoteControllerService {

    protected basePath = 'https://localhost:8084';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (let consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Daily update
     * Daily update
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public dailyUpdateUsingGET1(observe?: 'body', reportProgress?: boolean): Observable<Array<LoggingEntryDTO>>;
    public dailyUpdateUsingGET1(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<LoggingEntryDTO>>>;
    public dailyUpdateUsingGET1(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<LoggingEntryDTO>>>;
    public dailyUpdateUsingGET1(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<Array<LoggingEntryDTO>>(`${this.basePath}/api/reader/start/update/daily`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get arguments list for reader
     * Get arguments list for reader
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getArgumentListForReaderUsingGET1(observe?: 'body', reportProgress?: boolean): Observable<string>;
    public getArgumentListForReaderUsingGET1(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public getArgumentListForReaderUsingGET1(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public getArgumentListForReaderUsingGET1(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<string>(`${this.basePath}/api/reader/info`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Run reader for product type
     * Run reader for product type
     * @param productTypeString productTypeString
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public runReaderForProductTypeUsingGET1(productTypeString: string, observe?: 'body', reportProgress?: boolean): Observable<Array<LoggingEntryDTO>>;
    public runReaderForProductTypeUsingGET1(productTypeString: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<LoggingEntryDTO>>>;
    public runReaderForProductTypeUsingGET1(productTypeString: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<LoggingEntryDTO>>>;
    public runReaderForProductTypeUsingGET1(productTypeString: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (productTypeString === null || productTypeString === undefined) {
            throw new Error('Required parameter productTypeString was null or undefined when calling runReaderForProductTypeUsingGET1.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<Array<LoggingEntryDTO>>(`${this.basePath}/api/reader/start/${encodeURIComponent(String(productTypeString))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Say hi! :)
     * Say hi! :)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public sayHiUsingGET1(observe?: 'body', reportProgress?: boolean): Observable<string>;
    public sayHiUsingGET1(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public sayHiUsingGET1(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public sayHiUsingGET1(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<string>(`${this.basePath}/api/reader/hi`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
